export enum AppErrorType {
  PromiseTimeoutError = 'PromiseTimeoutError',
}

export type ApiErrorResponseError = {
  message: string
  type: AppErrorType | null
  code?: string
}

export type ApiErrorResponse = {
  errors: ApiErrorResponseError[]
  internalErrors?: ApiErrorResponseError[]
  message: string
}

export class ApiErrorObj extends Error {
  type?: AppErrorType
  errorData?: object
  status?: number
  code?: string

  constructor({
    error,
    errorData,
    type,
    status,
    code,
  }: {
    error: string
    errorData?: object
    type?: AppErrorType
    status?: number
    code?: string
  }) {
    super(error)

    this.errorData = errorData
    this.type = type
    this.status = status
    this.code = code
  }
}
